export const codeArr = [
    {
      code: `if (condition) {
    // code to be executed if the condition is true
  }`
    },
    {
      code: `#include <stdio.h>
  
  int main() {
    int age = 25;
    if (age >= 18) {
      printf("You are eligible to vote.\\n");
    }
    
    return 0;
  }`
    },
    {
      code: `if (condition) {
    // code to be executed if the condition is true
  } else {
    // code to be executed if the condition is false
  }`
    },
    {
      code: `#include <stdio.h>
  
  int main() {
    int num = 7;
    if (num % 2 == 0) {
      printf("The number is even.\\n");
    } else {
      printf("The number is odd.\\n");
    }
    
    return 0;
  }`
    },
    {
      code: `switch (expression) {
    case value1:
      // code to be executed if expression matches value1
      break;
    case value2:
      // code to be executed if expression matches value2
      break;
    // more case statements...
    default:
      // code to be executed if expression doesn't match any case
  }`
    },
    {
      code: `#include <stdio.h>
  
  int main() {
    int day = 3;
    switch (day) {
      case 1:
        printf("Monday\\n");
        break;
      case 2:
        printf("Tuesday\\n");
        break;
      case 3:
        printf("Wednesday\\n");
        break;
      default:
        printf("Invalid day\\n");
    }
    
    return 0;
  }`
    },
  ];
  